import{isNull,isString}from"@transferwise/neptune-validation";export var isBasicError=function(a){return isString(a)||isNull(a)};